import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BankWithBranchesEffects } from './bank-with-branches.effects';
import { STORE_TYPE } from './bank-with-branches.model';
import { bankWithBranchesReducer } from './bank-with-branches.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(STORE_TYPE, bankWithBranchesReducer),
    EffectsModule.forFeature([BankWithBranchesEffects]),
  ],
})
export class UIBankWithBranchesStoreModule {}
